var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBidicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.996,
    height: 21.356,
    viewBox: "0 0 21.996 21.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M-12297.6-4068.563l4.121-1.359v3.6h3.783l-1.758,3.305,3.059,2.039-3.059,1.893,1.758,3.087-3.783.762v3.7l-4.121-1.627-1.761,3-1.806-3-3.779,1.627v-3.7h-3.771l1.6-3.849-3.272-1.893,3.272-2.039-1.6-3.305h3.771v-3.6l3.779,1.359,1.806-2.957Z",
    transform: "translate(12310.389 4071.519)",
    fill: "#ff7200"
  }), /*#__PURE__*/React.createElement("text", {
    id: "BID",
    transform: "matrix(0.899, -0.438, 0.438, 0.899, 8.06, 13.78)",
    fill: "#fff",
    fontSize: 5,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BID")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBidicon);
export default __webpack_public_path__ + "static/media/Bid icon.b727a980b70fcd3d363c2aae46b7d3e2.svg";
export { ForwardRef as ReactComponent };